// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/validation.proto (package squareup.validation, syntax proto2)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions, MessageOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/validation.proto.
 */
export const file_squareup_common_validation: GenFile = /*@__PURE__*/
  fileDesc("CiBzcXVhcmV1cC9jb21tb24vdmFsaWRhdGlvbi5wcm90bxITc3F1YXJldXAudmFsaWRhdGlvbiIhCgVSYW5nZRILCgNtaW4YASABKAESCwoDbWF4GAIgASgBOkoKEGZpZWxkX3ZhbGlkYXRvcnMSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGJyuASABKAlSD2ZpZWxkVmFsaWRhdG9yczpRCgVyYW5nZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYna4BIAEoCzIaLnNxdWFyZXVwLnZhbGlkYXRpb24uUmFuZ2VSBXJhbmdlOjsKCHJlcXVpcmVkEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxiergEgASgIUghyZXF1aXJlZDo9CglyZXF1aXJlZDISHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKSuASABKAhSCXJlcXVpcmVkMjo8Cglub3RfZW1wdHkSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGJ+uASABKAhSCG5vdEVtcHR5OkgKD21hdGNoZXNfcGF0dGVybhIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYoK4BIAEoCVIObWF0Y2hlc1BhdHRlcm46UwoGbGVuZ3RoEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxihrgEgASgLMhouc3F1YXJldXAudmFsaWRhdGlvbi5SYW5nZVIGbGVuZ3RoOmQKD2NvbGxlY3Rpb25fc2l6ZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYoq4BIAEoCzIaLnNxdWFyZXVwLnZhbGlkYXRpb24uUmFuZ2VSDmNvbGxlY3Rpb25TaXplOk0KEm5vbl9uZWdhdGl2ZV9tb25leRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYo64BIAEoCFIQbm9uTmVnYXRpdmVNb25leTpBCgxtYXBfbWF4X3NpemUSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKWuASABKA1SCm1hcE1heFNpemU6YQoObWFwX2tleV9sZW5ndGgSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKauASABKAsyGi5zcXVhcmV1cC52YWxpZGF0aW9uLlJhbmdlUgxtYXBLZXlMZW5ndGg6UAoSbWVzc2FnZV92YWxpZGF0b3JzEh8uZ29vZ2xlLnByb3RvYnVmLk1lc3NhZ2VPcHRpb25zGJyuASABKAlSEW1lc3NhZ2VWYWxpZGF0b3JzQicKJWNvbS5zcXVhcmV1cC5wcm90b3MuY29tbW9uLnZhbGlkYXRpb24", [file_google_protobuf_descriptor]);

/**
 * * A range of numeric values 
 *
 * @generated from message squareup.validation.Range
 */
export type Range = Message<"squareup.validation.Range"> & {
  /**
   * * The minimum allowable value 
   *
   * @generated from field: optional double min = 1;
   */
  min: number;

  /**
   * * The maximum allowable value 
   *
   * @generated from field: optional double max = 2;
   */
  max: number;
};

/**
 * Describes the message squareup.validation.Range.
 * Use `create(RangeSchema)` to create a new message.
 */
export const RangeSchema: GenMessage<Range> = /*@__PURE__*/
  messageDesc(file_squareup_common_validation, 0);

/**
 * *
 * List of named validators to apply to this field.  Contains a comma-separated list
 * of validator names (repeated options are not supported as extensions to FieldOptions)
 *
 * @generated from extension: optional string field_validators = 22300;
 */
export const field_validators: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 0);

/**
 * * Indicates the minimum and maximum values for the field 
 *
 * @generated from extension: optional squareup.validation.Range range = 22301;
 */
export const range: GenExtension<FieldOptions, Range> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 1);

/**
 * *
 * Indicates that the field is required.  This is different from standard protobuf ``required``
 * in that it is an application constraint enforced through validation rather than
 * being a constraint enforced on the wire, and thus can be relaxed over time
 *
 * @generated from extension: optional bool required = 22302;
 */
export const required: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 2);

/**
 * *
 * Indicates that the field is required.  This is different from standard protobuf ``required``
 * in that it is an application constraint enforced through validation rather than
 * being a constraint enforced on the wire, and thus can be relaxed over time
 * If the type is an enum, this validation further is relaxed to include new enum values that
 * local code is not yet aware of.
 * TODO(dcarlson) this is likely sufficient to replace 'required'.
 *
 * @generated from extension: optional bool required2 = 22308;
 */
export const required2: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 3);

/**
 * * Indicates that the field must be present and not empty.  Applies to strings and byte strings 
 *
 * @generated from extension: optional bool not_empty = 22303;
 */
export const not_empty: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 4);

/**
 * * Indicates that the field must match the given regex.  Only applies to string fields 
 *
 * @generated from extension: optional string matches_pattern = 22304;
 */
export const matches_pattern: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 5);

/**
 * * Indicates that the field must have the given length constraints.  Applies to strings and byte strings 
 *
 * @generated from extension: optional squareup.validation.Range length = 22305;
 */
export const length: GenExtension<FieldOptions, Range> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 6);

/**
 * *
 * Indicates the minimum and maximum number elements allowed in a repeated field
 * (eg. array, set, etc.). A non-zero minimum value does not implicitly require the field to be provided.
 * Does not currently apply to maps.
 *
 * @generated from extension: optional squareup.validation.Range collection_size = 22306;
 */
export const collection_size: GenExtension<FieldOptions, Range> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 7);

/**
 * * Indicates that a squareup.connect.v2.common.Money message should have an unsigned amount. 
 *
 * @generated from extension: optional bool non_negative_money = 22307;
 */
export const non_negative_money: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 8);

/**
 * *
 * Indicates the maximum number elements allowed in a map field.
 *
 * @generated from extension: optional uint32 map_max_size = 22309;
 */
export const map_max_size: GenExtension<FieldOptions, number> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 9);

/**
 * * Indicates that the map's keys must have the given length constraints. 
 *
 * @generated from extension: optional squareup.validation.Range map_key_length = 22310;
 */
export const map_key_length: GenExtension<FieldOptions, Range> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 10);

/**
 * *
 * List of named validators to apply to this message.  Contains a comma-separated list
 * of validator names (repeated options are not supported as extensions to MessageOptions)
 *
 * @generated from extension: optional string message_validators = 22300;
 */
export const message_validators: GenExtension<MessageOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_common_validation, 11);

